import React from 'react';
import { useTranslation } from '../hooks/useTranslation.js';
import { companyContact } from '../config/company.js';
import { withLinks } from '../utils/textLinks.jsx';
import PageParts from './PageParts.jsx';
import { brandText } from './BrandText.jsx';

// The story on top of the IDD page, for a customer who is no developer: first
// the modernisation of grown business software with AI, then traceable AI
// development, which leads into the explanation of Intent-Driven Development
// below. All text comes from translations/pages/idd/<language>.js.
const IddStory = () => {
  const { currentLang, getPageTranslations } = useTranslation('agenticdev');
  const t = getPageTranslations('idd');

  return (
    <div className="bg-bg-main text-text-primary">
      <main className="site-main story-page">
        <PageParts current="legacy" />
        <section id="legacy" className="site-hero site-hero--single page-anchor">
          <div className="finance-hero">
            <p className="editorial-kicker">{t.kicker}</p>
            <h1 className="site-title">{t.title}</h1>
            <p className="finance-lead">{withLinks(t.lead, currentLang)}</p>
          </div>
        </section>

        <section className="signal-section">
          <div className="finance-features">
            {t.migration?.map((row) => (
              <article className="finance-feature" key={row.title}>
                <h3>{brandText(row.title)}</h3>
                <div>
                  {row.paragraphs?.map((paragraph, index) => (
                    <p key={index}>{withLinks(paragraph, currentLang)}</p>
                  ))}
                </div>
              </article>
            ))}
            {t.request && (
              <article className="finance-feature">
                <h3>{t.request.title}</h3>
                <div>
                  <p>{t.request.text}</p>
                  <a
                    className="site-text-link story-page__detail"
                    href={`mailto:${companyContact.email}?subject=${encodeURIComponent(t.request.subject || '')}`}
                  >
                    {t.request.cta}
                  </a>
                </div>
              </article>
            )}
          </div>
        </section>

        {t.method && (
          <section className="finance-analysis">
            <h2 className="site-heading">{t.method.title}</h2>
            <div className="finance-analysis__text">
              {t.method.paragraphs?.map((paragraph, index) => (
                <p key={index}>{withLinks(paragraph, currentLang)}</p>
              ))}
            </div>
          </section>
        )}
      </main>
    </div>
  );
};

export default IddStory;
